/*
 * COPYRIGHT Motorola Solutions, INC.
 * ALL RIGHTS RESERVED.
 * MOTOROLA SOLUTIONS CONFIDENTIAL RESTRICTED
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReasonCode } from '../model/reason-code';
import { SystemReasonCode } from '../model/system-reason-code';
import { SkipperService } from '../../core/services/skipper.service';

@Injectable({
    providedIn: 'root'
})
export class ReasonCodeService {
    private readonly REASON_CODES_SYSTEM_URL = '/api/config-mgmt/v1/reason-codes/system';
    private readonly REASON_CODES_CUSTOM_URL = '/api/config-mgmt/v1/reason-codes';

    // Toggle between mock data/real API endpoint ('assets/data/reason-codes.json'/ Skipper's REASON_CODES_CUSTOM_URL)
    private readonly USE_MOCK = false;
    private readonly MOCK_URL = 'assets/data/reason-codes.json';
    private readonly MOCK_SYSTEM_URL = 'assets/data/system-reason-codes.json';

    constructor(
        private readonly http: HttpClient,
        private readonly skipperService: SkipperService
    ) {}

    public fetchCustomReasonCodes(): Observable<ReasonCode[]> {
        if (this.USE_MOCK) {
            return this.http.get<ReasonCode[]>(this.MOCK_URL);
        }
        const url = `${this.skipperService.activeUrl$.value}${this.REASON_CODES_CUSTOM_URL}`;
        return this.http.get<ReasonCode[]>(url);
    }

    public fetchSystemReasonCodes(): Observable<SystemReasonCode[]> {
        if (this.USE_MOCK) {
            return this.http.get<SystemReasonCode[]>(this.MOCK_SYSTEM_URL);
        }
        const url = `${this.skipperService.activeUrl$.value}${this.REASON_CODES_SYSTEM_URL}`;
        return this.http.get<SystemReasonCode[]>(url);
    }
}
